import React, { PureComponent } from 'react';

import { FileBox } from 'src/components/basic';
import { DropBox, popupModel } from 'src/components/complex';

import {
  checkAvatarDimension,
  getFileType,
  getThumbnailFromVideoFile,
  humanFileSize,
  remCss,
  lang
} from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import AlertManager from 'components/alert/AlertManager';
import config from 'src/config';

const stylesFileBox = {
  2: {
    width: remCss(50),
    height: remCss(50)
  },
  3: {
    width: remCss(100),
    height: remCss(100)
  }
};

const MAX_TUS_FILE_SIZE = config.get('maxFileSize');

export class MediaDropBox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    };
  }

  onUpload = async (n, files) => {
    const { onChange, name, value = [], multi = true, dropImage = null } = this.props;

    if (files?.length > 0) {
      let hasImage = false;
      let videoError = null;
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > MAX_TUS_FILE_SIZE) {
          return AlertManager.popup(AlertManager.TYPES.WARN, {
            close: false,
            title: lang.t(LANG_CONST.validation.file_too_big, {
              size: humanFileSize(MAX_TUS_FILE_SIZE)
            }),
            actionButton: {
              label: LANG_CONST.buttons.ok,
              action: (actions) => actions.hide()
            }
          });
        }

        if (getFileType(files[i]) === 'image') {
          hasImage = true;
          if (!!dropImage && !(await checkAvatarDimension(files[i]))) return;
        }
        if (getFileType(files[i]) === 'video') {
          let thumbnail = await getThumbnailFromVideoFile(files[i]);
          if (thumbnail === null) {
            videoError = LANG_CONST.validation.video_invalid;
          } else {
            files[i] = { file: files[i], thumbnail };
          }
        }
      }

      if (videoError)
        return AlertManager.popup(AlertManager.TYPES.WARN, {
          close: false,
          title: videoError,
          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: (actions) => actions.hide()
          }
        });

      if (hasImage && !!dropImage)
        return popupModel.openCropImage({
          ...dropImage,
          src: files,
          onSave: (v) => {
            onChange(name, multi ? [...value, ...v] : [v[0]]);
          }
        });
    }

    onChange(name, multi ? [...value, ...files] : [files[0]]);
  };

  remove = (index) => () => {
    const { onChange, name, value = [], multi = true } = this.props;
    onChange(name, multi ? value.filter((item, i) => i !== index) : []);
  };

  render() {
    const {
      value = [],
      multi = true,
      style = {},
      template,
      media = [],
      onChangeMedia,
      fileBoxProps = {},
      prefixExpand = null,
      ...other
    } = this.props;

    let styles = { width: remCss(150), height: remCss(166) };
    if (template && stylesFileBox[template]) {
      styles = stylesFileBox[template];
    }
    return (
      <div
        className={
          'mc-media-dropbox' +
          (template ? ' template-' + template : (value + media).length === 0 ? '-empty' : '')
        }
        style={{ position: 'relative', ...style }}
      >
        {prefixExpand}
        {media?.map((item, index) => (
          <FileBox
            template={template === 3 ? 1 : template}
            videoProps={{ controls: false, playsinline: true, playing: false }}
            list={media}
            onlyPreview={true}
            key={'mc-media-' + index}
            file={item}
            onClose={() => onChangeMedia(item, index)}
            styles={styles}
            showFileName={true}
            {...fileBoxProps}
          />
        ))}
        {value?.map((item, index) => (
          <FileBox
            template={template === 3 ? 1 : template}
            videoProps={{ controls: false, playsinline: true, playing: false }}
            list={value}
            onlyPreview={true}
            key={'mc-media-' + index}
            file={item}
            onClose={this.remove(index)}
            styles={styles}
            showFileName={true}
            {...fileBoxProps}
          />
        ))}
        {!(!multi && (value.length > 0 || media?.length > 0)) && (
          <DropBox
            onUpload={this.onUpload}
            labelIcon={LANG_CONST.buttons.add_media}
            {...other}
            multiple={multi}
            dropBoxStyles={
              other.dropBoxStyles
                ? other.dropBoxStyles
                : template
                  ? {
                      height:
                        styles.height && template !== 2 ? styles.height - remCss(44) : styles.height
                    }
                  : undefined
            }
          />
        )}
      </div>
    );
  }
}
